import React, { useContext, useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faGlobe, faMoon, faSun, faTimes, faBars } from '@fortawesome/free-solid-svg-icons';
import styles from "./css/nav.module.css";
import { IdiomaContext } from '../components/context/IdiomaContext';
import { traducciones } from '../data/navData';
import { NavLink } from 'react-router-dom';
import '../styles/darkMode.css';
import './css/hamburgerMenu.css';

function Nav() {
  const { idioma, cambiarIdioma } = useContext(IdiomaContext);
  const textos = traducciones[idioma];
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 960);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const checkTime = useCallback(() => {
    if (isNightTime() && !isDarkMode) {
      setIsDarkMode(true);
      applyDarkMode(true);
    }
  }, [isDarkMode]);

  useEffect(() => {
    const storedMode = localStorage.getItem('darkMode');
    const initialDarkMode = storedMode ? JSON.parse(storedMode) : isNightTime();
    setIsDarkMode(initialDarkMode);
    applyDarkMode(initialDarkMode);

    const timer = setInterval(checkTime, 60000);
    return () => clearInterval(timer);
  }, [checkTime]);

  const isNightTime = () => {
    const currentHour = new Date().getHours();
    return currentHour >= 18 || currentHour < 6;
  };

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    applyDarkMode(newMode);
    localStorage.setItem('darkMode', JSON.stringify(newMode));
  };

  const applyDarkMode = (darkMode) => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  };

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLinkClick = () => {
    if (isMenuOpen) {
      toggleMenu();
    }
  };

  return (
    <div className={styles.nav}>
      <div className={styles.nav__container}>
        <NavLink to="/" className={styles.nav__containerLogo}>
          <div className={styles.nav__logo}></div>
        </NavLink>
        
        <div className={styles.nav__containerLinks}>
          <NavLink to="/" className={styles.nav__containerLink} onClick={handleLinkClick}>
            {textos.home}
          </NavLink>
          <NavLink to="/solutions" className={styles.nav__containerLink} onClick={handleLinkClick}>
            {textos.solutions}
          </NavLink>
          <NavLink to="/about" className={styles.nav__containerLink} onClick={handleLinkClick}>
            {textos.about}
          </NavLink>
          <NavLink to="/contact" className={styles.nav__containerLink} onClick={handleLinkClick}>
            {textos.contact}
          </NavLink>
        </div>

        <div className={styles.nav__icons}>
          <a href="https://www.facebook.com/qanticodevs/" target="_blank" rel="noopener noreferrer" className={styles.nav__github}>
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="https://www.instagram.com/qanticodevs/" target="_blank" rel="noopener noreferrer" className={styles.nav__linkedin}>
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>

        <div className={styles.nav__mode}>
          <div className={styles.nav__languageToggle}>
            <button onClick={() => cambiarIdioma(idioma === 'en' ? 'es' : 'en')} className={styles.nav__languageButton}>
              <FontAwesomeIcon icon={faGlobe} /> {idioma.toUpperCase()}
            </button>
          </div>

          <div className={styles.nav__darkModeToggle}>
            <button onClick={toggleDarkMode} className={styles.nav__modeButton}>
              <FontAwesomeIcon icon={isDarkMode ? faMoon : faSun} />
            </button>
          </div>
        </div>

        {/* Ícono de hamburguesa para móvil */}
        <div className="hamburger-menu">
          {/* Botón de menú */}
          <button className={`hamburger-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </button> 

          {/* Menú Desplegable */}
          <nav className={`menu ${isOpen ? 'active' : ''}`}>
            <div className={styles.nav__mode_movil}>
              <div className={styles.nav__languageToggle}>
                <button onClick={() => cambiarIdioma(idioma === 'en' ? 'es' : 'en')} className={styles.nav__languageButton_movil}>
                  <FontAwesomeIcon icon={faGlobe} /> {idioma.toUpperCase()}
                </button>
              </div>

              <div className={styles.nav__darkModeToggle}>
                <button onClick={toggleDarkMode} className={styles.nav__modeButton_movil}>
                  <FontAwesomeIcon icon={isDarkMode ? faMoon : faSun} />
                </button>
              </div>
            </div>
            <NavLink to="/" onClick={toggleMenu}>{textos.home}</NavLink>
            <NavLink to="/solutions" onClick={toggleMenu}>{textos.solutions}</NavLink>
            <NavLink to="/about" onClick={toggleMenu}>{textos.about}</NavLink>
            <NavLink to="/contact" onClick={toggleMenu}>{textos.contact}</NavLink>
            <a href="https://www.facebook.com/qanticodevs/" target="_blank" rel="noopener noreferrer" className={styles.nav__github}>
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/qanticodevs/" target="_blank" rel="noopener noreferrer" className={styles.nav__linkedin}>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Nav;
